import { createClient } from '@supabase/supabase-js'
import { createLogger } from './logger'

const log = createLogger('SupabaseClient')

// Configure from Vite environment variables
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string | undefined
// Development: Use service role key until Auth0 Action is fully working
const SUPABASE_KEY = ((import.meta.env as any).VITE_SUPABASE_SERVICE_ROLE_KEY ||
  (import.meta.env as any).VITE_SUPABASE_PUBLISHABLE_KEY ||
  (import.meta.env as any).VITE_SUPABASE_ANON_KEY) as string | undefined

if (!SUPABASE_URL || !SUPABASE_KEY) {
  // Fail early so environments without proper configuration are obvious
  throw new Error(
    '[supabaseClient] Missing VITE_SUPABASE_URL or SUPABASE key (VITE_SUPABASE_PUBLISHABLE_KEY/VITE_SUPABASE_ANON_KEY)',
  )
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
  auth: {
    detectSessionInUrl: false,
    persistSession: false,
    autoRefreshToken: false,
  },
  // Development: Service role key provides full access
})

export const supabaseAdmin = supabase

// Runtime diagnostics to confirm env actually used by the bundle
try {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ;(window as any).__supabaseEnv = {
    url: SUPABASE_URL,
    keyStart: SUPABASE_KEY.slice(0, 12),
    keySource: (import.meta.env as any).VITE_SUPABASE_PUBLISHABLE_KEY ? 'publishable' : 'anon',
  }

  log.info(
    'Using project:',
    SUPABASE_URL,
    'keySource:',
    (import.meta.env as any).VITE_SUPABASE_PUBLISHABLE_KEY ? 'publishable' : 'anon',
    'keyStart:',
    SUPABASE_KEY.slice(0, 12),
  )
} catch {}
